import { Link } from "react-router-dom";
import { BadgeRow } from "@/components/Badges";
import { Star, MapPin, Sparkles } from "lucide-react";

export default function BusinessCard({ b }) {
  return (
    <Link to={`/business/${b.id}`} data-testid={`business-card-${b.id}`}
      className={`group block rounded-2xl border bg-white p-6 shadow-sm hover:shadow-lg transition-all duration-200 ${b.featured ? "border-amber-400 ring-1 ring-amber-200 hover:border-amber-500" : "border-slate-200 hover:border-amber-400/60"}`}>
      {b.featured && (
        <div data-testid="featured-badge" className="mb-3 inline-flex items-center gap-1 rounded-full bg-amber-500 text-white text-[11px] font-bold px-2.5 py-0.5">
          <Sparkles size={11} /> Featured
        </div>
      )}
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-heading font-bold text-lg text-slate-950 group-hover:text-amber-700 transition-colors">
            {b.business_name}
          </h3>
          <div className="flex items-center gap-1 mt-1 text-sm text-amber-600 font-semibold">
            <Star size={14} className="fill-amber-500 text-amber-500" />
            {b.rating > 0 ? b.rating : "New"}
            <span className="text-slate-400 font-normal">({b.review_count})</span>
          </div>
        </div>
      </div>
      <p className="mt-3 text-sm text-slate-600 line-clamp-2 min-h-[2.5rem]">{b.bio || "Vetted Black-owned business on Black Umbrella."}</p>
      <div className="mt-3 flex flex-wrap gap-1.5">
        {(b.trades || []).slice(0, 3).map((t) => (
          <span key={t} className="text-xs px-2 py-0.5 rounded-md bg-slate-100 text-slate-700 font-medium">{t}</span>
        ))}
      </div>
      <div className="mt-3 flex items-center gap-1 text-xs text-slate-500">
        <MapPin size={12} /> {(b.service_areas || []).slice(0, 3).join(", ")}
      </div>
      <div className="mt-4 pt-4 border-t border-slate-100">
        <BadgeRow badges={b.badges} />
      </div>
    </Link>
  );
}
